import React, { Component } from 'react';

import '../css/quienessomos.css'

import logogr from '../img/logo-padilla-quienes.svg'

class Quienessomos extends Component {
  render() {
    return (
      <div className="container mt-4">

        <div className="row no-gutters">

          <div className="logoquienestodo container col-lg">
            <div className="row align-items-center p-lg-5 pt-5 pb-5">
              <div className="logocontenedor col-12">
                <img className="logoquienes" src={logogr} alt=""/>
              </div>

              <div className="textologo col-12">
                Líderes en el Mercado <br/> desde 1989
              </div>
            </div>
          </div>

          <div className="textoquienestodo container col-lg">
            <div className="row align-items-center no-gutters p-5">
              <div className="tituloquienes col-12 pb-3">
                ¿Quiénes Somos?
              </div>
              <div className="textoquienes col-12">
                <p>Ferretería Padilla, tu mejor opción al momento de construir.</p>
                <p>Con más de 30 años en el mercado, somos la Empresa ferretera más completa, distribuimos las marcas más importantes del país. Estamos enfocados en dar solución a cada necesidad de nuestros clientes, para lo cual contamos con un stock amplio y variado, lo que nos ha permitido garantizar el mejor servicio a los clientes más exigentes.</p>
              </div>
            </div>
          </div>

        </div>

      </div>
    )
  }
}

export default Quienessomos;
